// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.column-card {
  font-size: 16px;
  background: #fff;
  border-radius: 6px;
  width: 100%;
  padding: 34px;
}

textarea {
  min-height: 200px;
}

.aptsi-table-container {
  max-height: 410px; /* Adjust as needed */
  overflow-y: auto;
}

.bar-section {
  max-width: 1400px;
  background: #ffffff;
  border-radius: 3px;
  padding: 0; /* Remove padding to eliminate extra space */
  margin-top: 5px;
}

.bar-section .row {
  margin: 0; /* Remove default row margin */
}

.bar-section .tab-column {
  background-color: #A4B4BF; /* Default background color */
  color: white; /* Default text color */
  cursor: pointer;
  text-align: center;
  padding: 10px;
  font-size: 16px;
  border: 1px solid rgb(204, 202, 202);
  border-radius: 3px;
  transition: background-color 0.3s ease;
}

.bar-section .tab-column:hover {
  background-color: #6f8fa4; /* Darker shade on hover */
}

.bar-section .tab-column.active {
  background-color: #0060d6; /* Active tab background color */
  color: white; /* Active tab text color */
  font-weight: bold;
}

.btn-submit {
  background-color: #0060d6;
  color: white;
  transition: background 0.3s ease-in-out;
}
.btn-submit:hover {
  background-color: #1a1a86;
}`, "",{"version":3,"sources":["webpack://./src/app/features/ada-access/ruleset/ruleset-create-or-update/ruleset-create-or-update.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AACJ;;AACA;EACI,iBAAA;AAEJ;;AACA;EACI,iBAAA,EAAA,qBAAA;EACA,gBAAA;AAEJ;;AACE;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA,EAAA,4CAAA;EACA,eAAA;AAEJ;;AACE;EACE,SAAA,EAAA,8BAAA;AAEJ;;AACE;EACE,yBAAA,EAAA,6BAAA;EACA,YAAA,EAAA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,sCAAA;AAEJ;;AACE;EACE,yBAAA,EAAA,0BAAA;AAEJ;;AACE;EACE,yBAAA,EAAA,gCAAA;EACA,YAAA,EAAA,0BAAA;EACA,iBAAA;AAEJ;;AAEE;EACA,yBAAA;EACA,YAAA;EACA,uCAAA;AACF;AACE;EACE,yBAAA;AACJ","sourcesContent":[".column-card {\n    font-size: 16px;\n    background: #fff;\n    border-radius: 6px;\n    width: 100%;\n    padding: 34px;\n}\ntextarea {\n    min-height: 200px;\n}\n\n.aptsi-table-container {\n    max-height: 410px; /* Adjust as needed */\n    overflow-y: auto;\n  }\n\n  .bar-section {\n    max-width: 1400px;\n    background: #ffffff;\n    border-radius: 3px;\n    padding: 0; /* Remove padding to eliminate extra space */\n    margin-top: 5px;\n  }\n  \n  .bar-section .row {\n    margin: 0; /* Remove default row margin */\n  }\n  \n  .bar-section .tab-column {\n    background-color: #A4B4BF; /* Default background color */\n    color: white; /* Default text color */\n    cursor: pointer;\n    text-align: center;\n    padding: 10px;\n    font-size: 16px;\n    border: 1px solid rgb(204, 202, 202);\n    border-radius: 3px;\n    transition: background-color 0.3s ease;\n  }\n\n  .bar-section .tab-column:hover {\n    background-color: #6f8fa4; /* Darker shade on hover */\n  }\n  \n  .bar-section .tab-column.active {\n    background-color: #0060d6; /* Active tab background color */\n    color: white; /* Active tab text color */\n    font-weight: bold;\n  }\n\n\n  .btn-submit {\n  background-color: #0060d6;\n  color: #ffff;\n  transition: background 0.3s ease-in-out;\n\n  &:hover{\n    background-color: #1a1a86;\n  }\n}\n\n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
